import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink, withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  InputAdornment,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  TablePagination,
  TableSortLabel,
} from '@material-ui/core';
import moment from 'moment';

import {
  Search as SearchIcon,
} from 'react-feather';

import { SIREN_CONFIG, CONFIG_SETTINGS } from 'config.js';

import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateSensorQuerySensorId, updateSensorQueryInstalled } from 'actions/query';
import { getRoomTypeLabel } from 'utils/RoomType';
import { FormattedMessage, useIntl } from "react-intl";


const COLUMN_WIDTH = {
  // NO: '3%',
  SENSOR_ID: '10%',
  SerialNo: '5%',
  ROOM_NAME: '8%', //28
  INSTALL_DETAIL: '6%', //34
  ROOM_TYPE: '6%', //40
  WAKEUP: '6%', //45
  SLEEPANALYSIS: '8%', //55
  ISACTIVE: '5%', //60
  MEMO: '6%', //66
  SNAPSHOT: '4%', //70
  // BUCKET: '6%', //73
  STREAM: '6%', //76
  TIME: '10%', //86
  VERSION: '6%', //92
  TEMP: '6%', //100
  MAC: '8%', //96
  RSSI: '4%', //100
}


function descendingComparator(a, b, orderBy) {

  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}


function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}


function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}


const headCells = [
  // {
  //   id: 'no',
  //   numeric: false,
  //   disablePadding: true,
  //   width:COLUMN_WIDTH.NO,
  //   label: 'No',
  // },
  {
    id: 'deviceId',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.SENSOR_ID,
    label: <FormattedMessage id="device_sensor_id" />,
  },
  {
    id: 'serialProduct',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.SerialNo,
    label: <FormattedMessage id="serial_no" />,
  },

  {
    id: 'roomName',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.ROOM_NAME,
    label: <FormattedMessage id="room_name" />,
  },
  {
    id: 'installed_pos_detail',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.INSTALL_DETAIL,
    label: <FormattedMessage id="room_position" />,
  },

  // {
  //   id: 'keepOnFall',
  //   numeric: false,
  //   disablePadding: false,
  //   width:COLUMN_WIDTH.KEEP_ON_FALL,
  //   label: '"낙상"이벤트 유지',
  // },
  {
    id: 'roomType',
    numeric: false,
    disablePadding: true,
    width: COLUMN_WIDTH.ROOM_TYPE,
    label: <FormattedMessage id="room_type" />,
  },
  {
    id: 'wakeUpDetect',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.WAKEUP,
    label: <FormattedMessage id="wakeup" />,
  },
  {
    id: 'sleepAnalysis',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.SLEEPANALYSIS,
    label: <FormattedMessage id="sleepAnalysis" />,
  },
  {
    id: 'isActive',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.ISACTIVE,
    label: <FormattedMessage id="active" />,
  },
  {
    id: 'memo',
    numeric: true,
    disablePadding: false,
    width: COLUMN_WIDTH.MEMO,
    label: <FormattedMessage id="memo" />,
  },
  {
    id: 'timestamp',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.TIME,
    label: <FormattedMessage id="device_last_time" />,
  },
  {
    id: 'versionCode',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.VERSION,
    label: <FormattedMessage id="device_version" />,
  },
  {
    id: 'temperature',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.TEMP,
    label: <FormattedMessage id="device_temperature" />,
  },
  {
    id: 'wifiMac',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.MAC,
    label: <FormattedMessage id="device_mac" />,
  },
  {
    id: 'wifiState_rssi',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.RSSI,
    label: <FormattedMessage id="device_rssi" />,
  },
  {
    id: 'snapshotPresence',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.SNAPSHOT,
    label: <FormattedMessage id="presence_snap" />,
  },
  // {
  //   id: 'bucketName',
  //   numeric: false,
  //   disablePadding: false,
  //   width: COLUMN_WIDTH.BUCKET,
  //   label: <FormattedMessage id="S3_Bucket" />,
  // },
  {
    id: 'streamName',
    numeric: false,
    disablePadding: false,
    width: COLUMN_WIDTH.STREAM,
    label: <FormattedMessage id="S3_Stream" />,
  },


];


function EnhancedTableHead(props) {
  const { order, orderBy, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? 'right' : 'center'}
            align='center'
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            width={headCell.width}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {/* {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null} */}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};


const DeviceTable = props => {
  const { className, users, querySensorParams, DeviceListRowsPerPage, ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [order, setOrder] = React.useState('asc');
  // const [orderBy, setOrderBy] = React.useState('no');
  const [orderBy, setOrderBy] = React.useState('SENSOR_ID');


  const facility_id = useSelector((store) => store.user.facility_id);

  // const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rowsPerPage, setRowsPerPage] = useState(DeviceListRowsPerPage);

  const [page, setPage] = useState(0);

  const [listData, setListData] = useState([]);

  const [querySensorId, setQuerySensorId] = useState('');
  const [queryInstalled, setQueryInstalled] = useState('');


  const searchData = (sensorId, installed) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/device/deviceList?facility_id=${facility_id}&`;

    var params = '';
    if (sensorId) {
      params = 'deviceId=' + sensorId;
    }

    if (installed) {
      params += params.length > 0 ? '&' : '';
      params += 'roomName=' + installed;
    }

    url += params;

    fetch(url)
      .then(res => res.json())
      .then(snapshot => {
        var list = [];
        var idx = 1;
        if (snapshot.resultData != null) {
          snapshot.resultData.forEach(doc => {
            doc.no = idx++;
            list.push(doc);
          });
        }
        setListData(list);
      }
      );
  }


  useEffect(() => {

    //3중 하나 이상의 파라미터값이 있다면, 자동검색하여 화면에 그 결과를 표시하여, UX를 향상시킴.
    if (querySensorParams.sensorQuerySensorId || querySensorParams.sensorQueryInstalled) {
      searchData(querySensorParams.sensorQuerySensorId, querySensorParams.sensorQueryInstalled);
    }


    setQuerySensorId(querySensorParams.sensorQuerySensorId);
    setQueryInstalled(querySensorParams.sensorQueryInstalled);

    return () => { };
  }, []);



  const handleSearch = event => {
    searchData(querySensorId, queryInstalled);
  }


  /**
   * 검색 정보 지우기
   * @param {*} event
   */
  const handleClear = event => {
    props.updateSensorQuerySensorId('');
    props.updateSensorQueryInstalled('');

    setQuerySensorId('');
    setQueryInstalled('');
  }


  const handleQuerySensorId = (event) => {
    setQuerySensorId(event.target.value);
    props.updateSensorQuerySensorId(event.target.value);
  }

  const handleQueryRoomName = (event) => {
    setQueryInstalled(event.target.value);
    props.updateSensorQueryInstalled(event.target.value);
  }

  // const handleQueryPatientName = (event) => {
  //   setQueryPatientName(event.target.value);
  //   props.updateSensorQueryPatientName(event.target.value);
  // }

  const keyUp = (event) => {
    if (event.key === "Enter") {
      handleSearch();
      event.preventDefault();
    }
  }

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
    localStorage.setItem(CONFIG_SETTINGS.DeviceListRowsPerPage, event.target.value);
  };


  const startRow = (page * rowsPerPage);


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  return (

    //Device ID
    //위치구분 (시설 이름)
    //설치위치 (6층 A병실)
    //설치위치상세 (안쪽 모서리)
    //room 타입(bedroom bathroom, living room)
    //silent mode
    //이용자
    //  이름, 전화번호 등 인적사항
    //보호자
    //  이름, 전화번호 등 인적사항

    <Card className={clsx(classes.root, className)} {...rest} >

      <Box m={1} p={2}>

        <Box mt={2}
          display="flex"
          alignItems="center"
          justifyContent="start"
          flexGrow={1}>

          <TextField className={classes.queryField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
                </InputAdornment>
              )
            }}

            onChange={handleQuerySensorId}
            label={formatMessage({id:'device_sensor_id'})}
            placeholder={formatMessage({id:'device_sensor_id'})}
            value={querySensorId}
            variant="outlined"
            onKeyUp={keyUp}
          />


          <TextField className={classes.queryField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
                </InputAdornment>
              )
            }}

            onChange={handleQueryRoomName}
            label={formatMessage({id:'room_name'})}
            placeholder={formatMessage({id:'room_name'})}
            value={queryInstalled}
            variant="outlined"
            onKeyUp={keyUp}
          />


          {/* <TextField className={classes.queryField}
          InputProps={{startAdornment: (
            <InputAdornment position="start">
              <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
            </InputAdornment>
          )}}

          onChange={handleQueryPatientName}
          label="환자"
          placeholder="환자 이름"
          value={queryPatientName}
          variant="outlined"
          onKeyUp={keyUp}
        /> */}


          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.bulkAction}
            onClick={handleSearch}
          >
            <FormattedMessage id="search" />
          </Button>


          <Button
            variant="outlined"
            size="large"
            className={classes.bulkAction}
            onClick={handleClear}
          >
            <FormattedMessage id="initialize" />
          </Button>


        </Box>
      </Box>

      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>

              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={listData.length}
              />

              <TableBody>
                {/* {listData.slice(0+startRow, rowsPerPage+(page*rowsPerPage)).map(module => ( */}
                {stableSort(listData, getComparator(order, orderBy)).slice(0 + startRow, rowsPerPage + (page * rowsPerPage)).map(module => (

                  <TableRow
                    className={classes.tableRow}
                    key={module.deviceId}
                    component={RouterLink} to={`/devices/update/${module.deviceId}`}
                  >

                    {/* <TableCell width={COLUMN_WIDTH.NO}>{module.no}</TableCell> */}
                    <TableCell width={COLUMN_WIDTH.SENSOR_ID}>
                      <Typography variant="body2">{module.deviceId}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.SerialNo} >
                      <Typography variant="caption">{module.serialProduct}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.ROOM_NAME} align="center">
                      <Typography variant="body2">{module.roomName}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.INSTALL_DETAIL} align="center">
                      <Typography variant="body2">{module.installed_pos_detail}</Typography></TableCell>
                    {/* <TableCell width={COLUMN_WIDTH.KEEP_ON_FALL} align="center" >{module.keepOnFall == 1 ? 'M:수동': 'A:자동'}</TableCell> */}
                    <TableCell width={COLUMN_WIDTH.ROOM_TYPE} align="center">
                      <Typography variant="caption">{getRoomTypeLabel(module.roomType)}</Typography></TableCell>
                    <TableCell width={COLUMN_WIDTH.WAKEUP} align="center">
                      <Typography variant="body2">{module.wakeUpDetect == 1 ? formatMessage({id:'wakeup'}) : '-'}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.SLEEPANALYSIS} align="center">
                      <Typography variant="body2">{module.sleepAnalysis == 1 ? formatMessage({id:'sleepAnalysis'}) : '-'}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.ISACTIVE} align="center">
                      <Typography variant="body2">
                        {module.isActive == 1 ? formatMessage({id:'active'}) : formatMessage({id:'inactive'})}
                      </Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.MEMO} ><Typography variant="body2">{module.memo}</Typography></TableCell>

                    <TableCell width={COLUMN_WIDTH.TIME} >
                      <Typography variant="body2">{moment(module.timestamp).format('YY.MM.DD HH:mm')}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.VERSION} >
                      <Typography variant="body2">{module.versionCode}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.TEMP} >
                      <Typography variant="caption">{module.temperature}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.MAC} >
                      <Typography variant="caption">{module.wifiMac}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.RSSI} >
                      <Typography variant="body2">{module.wifiState_rssi}</Typography>
                    </TableCell>

                    <TableCell width={COLUMN_WIDTH.SNAPSHOT} >
                      <Typography variant="body2">{module.snapshotPresence == 1 ? 'ON' : 'OFF'}</Typography>
                    </TableCell>
                    {/* <TableCell width={COLUMN_WIDTH.BUCKET} >
                      <Typography variant="body2">{module.bucketName}</Typography>
                    </TableCell> */}
                    <TableCell width={COLUMN_WIDTH.STREAM} >
                      <Typography variant="body2">{module.streamName}</Typography>
                    </TableCell>


                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>

      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={listData.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

DeviceTable.propTypes = {
  className: PropTypes.string,
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateSensorQuerySensorId,
    updateSensorQueryInstalled,
  }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    querySensorParams: state.querySensorParams
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DeviceTable));




const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // marginLeft: theme.spacing(1)
  },
  queryField: {
    // width: 300
    flexBasis: 260,
    marginRight: 20,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
}));
